import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Java = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M8.83062 17.4669C8.83062 17.4669 8.05391 17.9113 9.38411 18.0613C10.9959 18.2423 11.8195 18.2164 13.5951 17.8863C13.5951 17.8863 14.0629 18.1739 14.715 18.4232C10.733 20.1008 5.70343 18.326 8.83062 17.4669ZM8.34377 15.2774C8.34377 15.2774 7.4724 15.9117 8.80374 16.0473C10.5255 16.2221 11.8848 16.2363 14.2382 15.7909C14.2382 15.7909 14.563 16.1154 15.0744 16.2926C10.261 17.6769 4.89983 16.4015 8.34377 15.2774Z"
      fill="currentColor"
    />
    <path
      d="M12.4453 11.5628C13.427 12.6739 12.1879 13.6729 12.1879 13.6729C12.1879 13.6729 14.679 12.4086 13.5352 10.8246C12.4665 9.34817 11.6473 8.61483 16.0827 6.08522C16.0827 6.08522 9.12032 7.79481 12.4453 11.5628Z"
      fill="currentColor"
    />
    <path
      d="M17.7115 19.0866C17.7115 19.0866 18.2865 19.5528 17.078 19.9132C14.7803 20.5976 7.51281 20.804 5.49438 19.9406C4.76916 19.63 6.12966 19.1995 6.55769 19.1087C7.00397 19.0137 7.2588 19.031 7.2588 19.031C6.45178 18.4723 2.04278 20.1285 5.01959 20.6036C13.1371 21.8975 19.8168 20.0208 17.7115 19.0866ZM9.20456 13.0085C9.20456 13.0085 5.50823 13.8719 7.89571 14.1858C8.90394 14.3185 10.9129 14.288 12.7855 14.1336C14.3155 14.0072 15.8508 13.7372 15.8508 13.7372C15.8508 13.7372 15.3118 13.9645 14.9214 14.2263C11.1671 15.1975 3.9162 14.7451 6.00388 13.7524C7.76878 12.913 9.20456 13.0085 9.20456 13.0085ZM15.8355 16.6531C19.6516 14.7036 17.887 12.8302 16.6554 13.0825C16.3543 13.1442 16.2192 13.1979 16.2192 13.1979C16.2192 13.1979 16.3313 13.025 16.5451 12.9506C18.9814 12.1087 20.8548 15.4346 15.7592 16.7519C15.7592 16.7516 15.8177 16.6996 15.8355 16.6531Z"
      fill="currentColor"
    />
    <path
      d="M13.5352 2C13.5352 2 15.6481 4.07906 11.5306 7.27504C8.22858 9.83958 10.7777 11.3015 11.5295 12.9724C9.60179 11.2624 8.18785 9.75674 9.13629 8.35559C10.529 6.29928 14.3875 5.30189 13.5352 2Z"
      fill="currentColor"
    />
    <path
      d="M9.57963 21.9373C13.2417 22.1675 18.8669 21.8091 19 20.1049C19 20.1049 18.744 20.751 15.9732 21.2635C12.8471 21.8423 8.99079 21.7748 6.70433 21.4036C6.70433 21.4036 7.17277 21.7851 9.57963 21.9373Z"
      fill="currentColor"
    />
  </Icon>
));

export default Java;
